import React, { useState, useCallback } from 'react';
import { Box, IconButton, InputBase } from '@mui/material';
import { theme } from 'utils/theme';
import PropTypes from 'prop-types';
import SendIcon from '@mui/icons-material/Send';

const ChatInput = ({ onSend, disabled }) => {
  const [message, setMessage] = useState('');

  const handleSend = useCallback(() => {
    const trimmed = message.trim();
    if (!trimmed) {
        return;
    }
    onSend(trimmed);
    setMessage('');
  }, [message, onSend]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box
      sx={{
        paddingX: '14px',
        paddingY: '4px',
        backgroundColor: theme.palette.background.paper,
        borderTop: '1px solid',
        borderColor: theme.palette.grey[300],
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <InputBase
        fullWidth
        multiline
        maxRows={2}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type your message"
        disabled={disabled}
        value={message}
      />
      <IconButton 
        sx={{ p: '10px' }} 
        aria-label="send" 
        onClick={handleSend} 
        disabled={disabled}>
        <SendIcon />
      </IconButton>
    </Box>
  );
};

ChatInput.propTypes = {
  onSend: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default ChatInput;
